module.exports = __webpack_public_path__ + "static/img/latest-activity-created.b06aae7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/latest-activity-created.svg
// module id = 454
// module chunks = 0